var _path, _circle, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFixes = function SvgFixes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.446 33.04H42.74L32.236 43.542v6.706L42.74 60.752h6.706L59.949 50.25v-6.706L49.446 33.04Z",
    stroke: "currentColor",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.095,
    cy: 46.821,
    r: 6.074,
    stroke: "currentColor",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m79.876 52.47-5.336-5.336h-3.407l-5.336 5.336",
    stroke: "currentColor",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.837 48.308c0 12.373-10.03 22.404-22.404 22.404M13.733 38.391l5.337 5.336h3.406l5.337-5.336",
    stroke: "currentColor",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.612 42.553c0-12.373 10.03-22.403 22.404-22.403",
    stroke: "currentColor",
    strokeWidth: 3
  })));
};
export default SvgFixes;